/**
 * Map camelCase GraphQL response keys back to snake_case
 * to match existing TypeScript interfaces.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

const camelToSnake: Record<string, string> = {
  childCount: "child_count",
  baseRequirementId: "base_requirement_id",
  projectVariants: "project_variants",
  canEdit: "can_edit",
  editableFields: "editable_fields",
  activeUser: "active_user",
  activeProject: "active_project",
  parentId: "parent_id",
  requirementLevel: "requirement_level",
  requirementDrivers: "requirement_drivers",
  sourceDrivers: "source_drivers",
  drivenRequirements: "driven_requirements",
  activeDriverCount: "active_driver_count",
  requirementDriverCount: "requirement_driver_count",
  sourceDriverCount: "source_driver_count",
  drivenChildCount: "driven_child_count",
  isActive: "is_active",
  correctnessIssues: "correctness_issues",
  driverType: "driver_type",
  jiraTickets: "jira_tickets",
  jiraStatus: "jira_status",
  allDone: "all_done",
  hasIssues: "has_issues",
  testStatus: "test_status",
  relatedTests: "related_tests",
  linkedRequirements: "linked_requirements",
  startDate: "start_date",
  endDate: "end_date",
  projectId: "project_id",
  projectName: "project_name",
  projectStatus: "project_status",
  releaseVersions: "release_versions",
  skuName: "sku_name",
  updatedOn: "updated_on",
  statusText: "status_text",
  statusVersion: "status_version",
  defaultReportDate: "default_report_date",
  earliestReportDate: "earliest_report_date",
  latestReportDate: "latest_report_date",
  historyReady: "history_ready",
  reportDate: "report_date",
  capturedAt: "captured_at",
  generatedAt: "generated_at",
  snapshotDate: "snapshot_date",
  parentCount: "parent_count",
  childCount2: "child_count",
  completionCounts: "completion_counts",
  testCount: "test_count",
  testTypes: "test_types",
  testSuites: "test_suites",
  depthCounts: "depth_counts",
  levelCounts: "level_counts",
  childrenWithTests: "children_with_tests",
  childrenWithoutTests: "children_without_tests",
  activeRequirementCount: "active_requirement_count",
  inactiveRequirementCount: "inactive_requirement_count",
  correctRequirementCount: "correct_requirement_count",
  incorrectRequirementCount: "incorrect_requirement_count",
  missingActiveDriversCount: "missing_active_drivers_count",
  missingImplementationTestsCount: "missing_implementation_tests_count",
  groupingWithTestsCount: "grouping_with_tests_count",
  groupingWithSourceDriversCount: "grouping_with_source_drivers_count",
  systemWithoutSourceDriversCount: "system_without_source_drivers_count",
  systemWithoutDrivenChildrenCount: "system_without_driven_children_count",
  totalCustomerReqs: "total_customer_reqs",
  customerReqsWithProduct: "customer_reqs_with_product",
  translationTarget: "translation_target",
  incorporationTarget: "incorporation_target",
  completionTarget: "completion_target",
  automationTarget: "automation_target",
  totalProductReqs: "total_product_reqs",
  productReqsWithTests: "product_reqs_with_tests",
  reqsCompleted: "reqs_completed",
  reqsAutomated: "reqs_automated",
  reqId: "req_id",
  hasTests: "has_tests",
  allTestsDone: "all_tests_done",
  testId: "test_id",
  totalRows: "total_rows",
  withTimeline: "with_timeline",
  allDone2: "all_done",
  issueCount: "issue_count",
  totalKeys: "total_keys",
  userId: "user_id",
  userRole: "user_role",
  entityType: "entity_type",
  entityId: "entity_id",
  requestBody: "request_body",
  responseStatus: "response_status",
  responseBody: "response_body",
  durationMs: "duration_ms",
};

function toSnakeKey(key: string): string {
  return camelToSnake[key] || key;
}

export function mapToSnakeCase(obj: any): any {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(mapToSnakeCase);
  if (typeof obj !== "object") return obj;

  // Skip __typename
  const result: any = {};
  for (const [key, value] of Object.entries(obj)) {
    if (key === "__typename") continue;
    result[toSnakeKey(key)] = mapToSnakeCase(value);
  }
  return result;
}
